module.exports = __webpack_public_path__ + "media/dummyvideo.d9061d3d.mp4";